<script setup lang="ts">
import { onMounted, onBeforeUnmount } from 'vue'
import { useToast } from 'primevue/usetoast'
import Toast from 'primevue/toast'
import ConfirmDialog from 'primevue/confirmdialog'
import type { AppToastEvent } from '@/plugins/toast'

const toast = useToast()

function handle(event: Event) {
  const detail = (event as CustomEvent<AppToastEvent>).detail
  toast.add(detail)
}

onMounted(() => window.addEventListener('app-toast', handle))
onBeforeUnmount(() => window.removeEventListener('app-toast', handle))
</script>

<template>
  <RouterView />
  <Toast position="top-right" />
  <ConfirmDialog />
</template>
